import { render, staticRenderFns } from "./addafPamseMange.vue?vue&type=template&id=168bb294&"
import script from "./addafPamseMange.vue?vue&type=script&lang=js&"
export * from "./addafPamseMange.vue?vue&type=script&lang=js&"
import style0 from "./addafPamseMange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168bb294')) {
      api.createRecord('168bb294', component.options)
    } else {
      api.reload('168bb294', component.options)
    }
    module.hot.accept("./addafPamseMange.vue?vue&type=template&id=168bb294&", function () {
      api.rerender('168bb294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addafPamseMange.vue"
export default component.exports